import React from 'react'
import s from './WhyShouldITest.module.css'
import Image from "next/legacy/image"
import { urlFor } from '@lib/sanity'
import { SwiperSlide } from 'swiper/react'

export interface IListForm {
  content: string
  title: string
  image: any
}

export interface WhyShouldITestProps {
  title?: string
  image?: any
  list?: Array<IListForm>
}

const WhyShouldITest: React.FC<WhyShouldITestProps> = ((props) => {
  const {
    title,
    image,
    list
  } = props

  return (
    <div className={`${s.root}`}>
      <div>
        <div className={`${s.grid} grid grid-cols-1 lg:grid-cols-2 h-full`}>
          <div className='mx-space6 md:mx-space16 py-space8 md:py-16'>
            <div className={s.titleCover + ' lg:pb-space8 lg:mb-space8'}>
              <h3 className={`${s.title}`}>{title}</h3>
            </div>
            <div className={'mt-space12 md:mt-0'}>
              {list && list.map((item: any, index: number) => {
                  const imageUrl = urlFor(item?.image).url()
                  return <div key={'wsit' + index}>
                    <div className={'mt-space6 mb-1'}>
                      <div className={'flex justify-center align-start'}>
                        {item.image && imageUrl &&
                          <div>
                            <div className={'hidden md:block rounded-full mr-space6 mb-space6 w-e107 flex-row relative aspect-square overflow-hidden'}>
                              <Image priority={false} loading="lazy" alt={'WhyList desktop' + index} src={imageUrl} objectFit={'cover'} layout={'fill'}
                                     objectPosition={'center center'} />
                            </div>
                            <div className={'md:hidden rounded-full mr-space3 mb-space3 flex-row relative w-e71 aspect-square overflow-hidden'}>
                              <Image priority={false} loading="lazy" alt={'WhyList mobile' + index} src={imageUrl} objectFit={'cover'} layout={'fill'}
                                     objectPosition={'center center'} />
                            </div>
                          </div>
                        }
                        <div className={'text-paragraph03 text-neutral900 flex-1 align-middle md:pr-space12'}>
                          <h3
                            className={'text-paragraph03 md:text-heading03Mobile md:text-subheading font-medium mt-space1 md:mt-space2 mb-space4'}>{item.title}</h3>
                          <p className={'block'}>{item.content}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              )}
            </div>
          </div>
          <div className={'hidden md:block'}>
            {image && <div
              className={s.image + ' block w-full h-full block overflow-hidden relative'}>
              <Image priority={false} loading="lazy" alt={'WhyList image'} src={image} layout='fill' objectFit='cover' />
            </div>}
          </div>
        </div>
      </div>
    </div>
  )
})

export default WhyShouldITest
